<template>
  <tooltip :disabled="hasEnoughTokens && hasValidLicense" text="_">
    <template v-slot:text>
      <div class="tooltipLowCreditWarning">
        <strong>{{ feedbackLabel }}</strong>

        <span>
          {{ t("generic") }}
        </span>
      </div>
    </template>

    <slot :disabled="!hasEnoughTokens || !hasValidLicense" />
  </tooltip>
</template>

<script lang="ts">
import { defineComponent, computed } from "@vue/composition-api"
import { OrganizationModule } from "@/store"
import Tooltip from "@/components/tooltip/TooltipRoot.vue"
import { createTranslationModule } from "@/plugins/i18n"

export default defineComponent({
  name: "EnoughTokens",
  setup() {
    const organizationModule = OrganizationModule()
    const t = createTranslationModule("TriCaster.boxHeader.tokenWarning")

    const hasEnoughTokens = computed(() => {
      const tokenCount = organizationModule.walletDetail.amount ?? 0
      return tokenCount > 0
    })

    const hasValidLicense = computed(() => {
      const subscription = organizationModule.organizationDetail.tokenSubscription

      if (subscription) {
        const expirationDate = new Date(subscription.expirationDate).getTime()
        return expirationDate > Date.now()
      }

      return false
    })

    const feedbackLabel = computed(() => {
      if (!hasValidLicense.value) {
        return t("licenseExpired")
      } else if (!hasEnoughTokens) {
        return t("outOfCredits")
      }

      return ""
    })

    return {
      t,
      feedbackLabel,
      hasValidLicense,
      hasEnoughTokens
    }
  },
  components: {
    Tooltip
  }
})
</script>
